import React from 'react';
import './HowItWorksSection.scss';
import uploadCredentials from '../assets/UploadCredentials.png';
import findWork from '../assets/FindWork.png';
import youGotPaid from '../assets/YouGotPaid.png';

const HowItWorksSection = () => {
  return (
    <>
      {/* Stats Section */}
      <section id="stats" className="how-it-works-section__stats-section scroll-animate fade-in">
        <div className="stats__item scroll-animate fade-up stagger-1">
          <div className="stats__number">25K+</div>
          <div className="stats__label">Athletic Trainers</div>
        </div>
        <div className="stats__item scroll-animate fade-up stagger-2">
          <div className="stats__number">$35M+</div>
          <div className="stats__label">Earned by ATs</div>
        </div>
        <div className="stats__item scroll-animate fade-up stagger-3">
          <div className="stats__number">695K+</div>
          <div className="stats__label">Hours Worked</div>
        </div>
      </section>

      <section id="how-it-works" className="how-it-works-section scroll-animate fade-in">
        <h2 className="how-it-works-section__title scroll-animate fade-up stagger-1">How It Works</h2>

        <div className="how-it-works-section__content">
          {/* Step 1 - Upload Credentials */}
          <div className="how-it-works-section__item scroll-animate slide-left stagger-2">
            <img
              src={uploadCredentials}
              alt="Upload Credentials"
              className="how-it-works-section__mockup-image"
            />
            <div className="how-it-works-section__step">
              <div className="step__header">
                <span className="step__number">01</span>
                <h3 className="step__title">Upload Credentials</h3>
              </div>
              <p className="step__description">
                Set up your profile with your national credentials, state licensure and professional liability
                insurance.
              </p>
            </div>
          </div>

          {/* Step 2 - Pick a Job */}
          <div className="how-it-works-section__item scroll-animate fade-up stagger-3">
            <img src={findWork} alt="Pick a Job" className="how-it-works-section__mockup-image" />
            <div className="how-it-works-section__step">
              <div className="step__header">
                <span className="step__number">02</span>
                <h3 className="step__title">Pick a Job</h3>
              </div>
              <p className="step__description">
                Search the job feed for a job that fits your schedule and pay criteria.
              </p>
            </div>
          </div>

          {/* Step 3 - Work & Get Paid */}
          <div className="how-it-works-section__item scroll-animate slide-right stagger-4">
            <img src={youGotPaid} alt="Work & Get Paid" className="how-it-works-section__mockup-image" />
            <div className="how-it-works-section__step">
              <div className="step__header">
                <span className="step__number">03</span>
                <h3 className="step__title">Work & Get Paid</h3>
              </div>
              <p className="step__description">
                All payments are guaranteed. No chasing down people for money.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HowItWorksSection;
